import DossiersTechniquesTab from "@features/creation/dossier-techniques/components/DossiersTechniquesTab";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Folder } from "lucide-react";

export const Route = createFileRoute("/_app/creation/dossier-techniques/")({
  loader: requirePermission(PERMISSIONS.CREATION.DOSSIER_TECHNIQUES.VIEW),
  staticData: {
    title: "Dossiers Techniques",
    icon: Folder,
    tab_icon: Folder,
    permission: PERMISSIONS.CREATION.DOSSIER_TECHNIQUES.VIEW,
    module: "creation",
    section: "Creation",
    order: 26,
    description: "Gestion des dossiers techniques",
    showInNav: true,
    showInTab: true,
    showInBreadcrumb: true,
  },
  component: DossiersTechniquesTab,
});
